import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createElement, Fragment } from "@wordpress/element";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';

// Props

// All Jobs

// Single Job

var GreenhouseAPIComponent = function GreenhouseAPIComponent(_ref) {
  var _regions$find, _regions$find$title, _regions$find2;
  var section = _ref.section;
  var filters = useRef(null);

  // All Jobs
  var _useState = useState([{
      code: 'telixus',
      title: 'US'
    }, {
      code: 'telixapac',
      title: 'APAC'
    }, {
      code: 'telixemea',
      title: 'EMEA'
    }]),
    _useState2 = _slicedToArray(_useState, 1),
    regions = _useState2[0];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filterRegion = _useState6[0],
    setFilterRegion = _useState6[1]; // Select
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    filterRegions = _useState8[0],
    setFilterRegions = _useState8[1]; // Buttons
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    filterRole = _useState0[0],
    setFilterRole = _useState0[1]; // Select
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    filterRoles = _useState10[0],
    setFilterRoles = _useState10[1]; // Buttons
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    jobs = _useState12[0],
    setJobs = _useState12[1];
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    loadingAllJobs = _useState14[0],
    setLoadingAllJobs = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    error = _useState16[0],
    setError = _useState16[1];
  var jobsByRegion = filterRegion ? jobs.filter(function (job) {
    return job.region === filterRegion;
  }) : jobs.filter(function (job) {
    return filterRegions.length === 0 || filterRegions.includes(job.region || '');
  });
  var roles = Array.from(new Set(jobsByRegion.map(function (job) {
    return job.title;
  }))).sort();

  // Single Job
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    singleJob = _useState18[0],
    setSingleJob = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    singleJobID = _useState20[0],
    setSingleJobID = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    singleJobRegion = _useState22[0],
    setSingleJobRegion = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    loadingSingleJob = _useState24[0],
    setLoadingSingleJob = _useState24[1];

  // Misc.
  var clearSingleJob = function clearSingleJob() {
    setSingleJob(null);
    setSingleJobID(null);
    setSingleJobRegion(null);
    var url = new URL(window.location.href);
    if (!filterRegion) {
      url.searchParams.delete('region');
    }
    url.searchParams.delete('gh_jid');
    window.history.replaceState({}, '', url.toString());
  };

  // Filter Select
  var handleChangeRegion = function handleChangeRegion(e) {
    clearSingleJob();
    setFilterRole('');
    setFilterRegion(e.target.value);
    var url = new URL(window.location.href);
    url.searchParams.delete('region');
    window.history.replaceState({}, '', url.toString());
    if (e.target.value) {
      var _url = new URL(window.location.href);
      _url.searchParams.set('region', e.target.value);
      window.history.replaceState({}, '', _url.toString());
    }
  };

  // Filter Buttons
  var handleRegionClick = function handleRegionClick(code) {
    setFilterRegions(function (prev) {
      return prev.includes(code) ? prev.filter(function (r) {
        return r !== code;
      }) : [].concat(_toConsumableArray(prev), [code]);
    });
    setFilterRoles([]);
    clearSingleJob();
  };
  var handleRoleClick = function handleRoleClick(code) {
    setFilterRoles(function (prev) {
      return prev.includes(code) ? prev.filter(function (r) {
        return r !== code;
      }) : [].concat(_toConsumableArray(prev), [code]);
    });
    clearSingleJob();
  };

  // Check URL Params on Load
  useEffect(function () {
    var params = new URLSearchParams(window.location.search);

    // Load Filtered Jobs
    var regionParam = params.get('region');
    // if (regionParam) setFilterRegion(regionParam); // Select (Single value only)
    if (regionParam) {
      setFilterRegions(regionParam.split(','));
    }

    // Load Single Job
    var jobIdParam = params.get('gh_jid');
    if (jobIdParam) {
      setSingleJobID(jobIdParam);
      setSingleJobRegion(regionParam);
    }
  }, []);

  // Update URL Params
  useEffect(function () {
    var url = new URL(window.location.href);
    if (filterRegions.length === 0) {
      url.searchParams.delete('region');
    } else {
      var other = new URLSearchParams(url.search);
      other.delete('region');
      var qs = other.toString();
      var prefix = qs ? "?".concat(qs, "&") : '?';
      url.search = "".concat(prefix, "region=").concat(filterRegions.join(','));
    }
    window.history.replaceState({}, '', url.toString());
  }, [filterRegions]);

  // Get jobs from all regions
  useEffect(function () {
    var controller = new AbortController();
    setLoadingAllJobs(true);
    setError(null);
    var getJobs = function getJobs(region) {
      return fetch("https://boards-api.greenhouse.io/v1/boards/".concat(region, "/jobs"), {
        signal: controller.signal
      }).then(function (res) {
        if (!res.ok) throw new Error("".concat(region, ": HTTP ").concat(res.status));
        return res.json();
      }).then(function (data) {
        var _data$jobs;
        return ((_data$jobs = data.jobs) !== null && _data$jobs !== void 0 ? _data$jobs : []).map(function (j) {
          return _objectSpread(_objectSpread({}, j), {}, {
            region: region
          });
        });
      });
    };
    Promise.allSettled(regions.map(function (r) {
      return getJobs(r.code);
    })).then(function (results) {
      var fulfilled = results.filter(function (r) {
        return r.status === 'fulfilled';
      });
      var rejected = results.filter(function (r) {
        return r.status === 'rejected';
      });
      var combined = fulfilled.flatMap(function (r) {
        return r.value;
      });

      // Sort newest updated/published first
      combined.sort(function (a, b) {
        var _ref2, _a$updated_at, _ref3, _b$updated_at;
        var da = (_ref2 = (_a$updated_at = a.updated_at) !== null && _a$updated_at !== void 0 ? _a$updated_at : a.first_published) !== null && _ref2 !== void 0 ? _ref2 : '';
        var db = (_ref3 = (_b$updated_at = b.updated_at) !== null && _b$updated_at !== void 0 ? _b$updated_at : b.first_published) !== null && _ref3 !== void 0 ? _ref3 : '';
        return db.localeCompare(da);
      });
      setJobs(combined);
      if (rejected.length) {
        var messages = rejected.map(function (r) {
          return r.reason instanceof Error ? r.reason.message : String(r.reason);
        });
        setError(fulfilled.length ? "Some regions failed: ".concat(messages.join(' | ')) : "Failed to load jobs: ".concat(messages.join(' | ')));
      }
    }).catch(function (err) {
      if ((err === null || err === void 0 ? void 0 : err.name) === 'AbortError') return;
      setError(err instanceof Error ? err.message : 'Unknown error');
    }).finally(function () {
      setLoadingAllJobs(false);
    });
    return function () {
      return controller.abort();
    };
  }, []);

  // Get single job details
  useEffect(function () {
    if (!singleJobID || !singleJobRegion) return;
    var controller = new AbortController();
    setLoadingSingleJob(true);
    setError(null);
    var url = "https://boards-api.greenhouse.io/v1/boards/".concat(singleJobRegion, "/jobs/").concat(singleJobID);
    fetch(url, {
      signal: controller.signal
    }).then(function (res) {
      if (!res.ok) throw new Error("HTTP ".concat(res.status));
      return res.json();
    }).then(function (data) {
      setSingleJob(data);
    }).catch(function (err) {
      if ((err === null || err === void 0 ? void 0 : err.name) === 'AbortError') return;
      setError(err instanceof Error ? err.message : 'Unknown error');
    }).finally(function () {
      setLoadingSingleJob(false);
      setTimeout(function () {
        var offset = 90;
        var elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }, 300);
    });
    return function () {
      return controller.abort();
    };
  }, [singleJobID, singleJobRegion]);

  // Greenhouse
  useEffect(function () {
    if (!singleJobRegion) return;
    var container = document.getElementById('grnhse_app');
    if (!container) return;
    container.innerHTML = '';
    var _startEmbed = function startEmbed() {
      var _GH$Iframe;
      var GH = window.Grnhse;
      if (GH !== null && GH !== void 0 && (_GH$Iframe = GH.Iframe) !== null && _GH$Iframe !== void 0 && _GH$Iframe.load) {
        GH.Iframe.load(singleJobID || undefined);
      } else {
        setTimeout(_startEmbed, 25);
      }
    };
    var selector = "script[src*=\"https://boards.greenhouse.io/embed/job_board/js?for=".concat(singleJobRegion, "\"]");
    var existing = document.querySelector(selector);
    if (existing) {
      _startEmbed();
      return;
    }
    var script = document.createElement('script');
    script.src = "https://boards.greenhouse.io/embed/job_board/js?for=".concat(encodeURIComponent(singleJobRegion), "&t=").concat(Date.now());
    script.async = true;
    script.dataset.ghEmbed = 'true';
    script.onload = _startEmbed;
    script.onerror = function () {
      console.error('Failed to load Greenhouse embed script');
    };
    (document.head || document.body).appendChild(script);
    return function () {
      container.innerHTML = '';
    };
  }, [singleJobRegion, singleJobID]);

  // Greenhouse - Remove iFrame
  useEffect(function () {
    if (singleJob) return;
    var container = document.getElementById('grnhse_app');
    if (container) {
      container.innerHTML = '';
    }
  }, [singleJob]);

  // Accordions

  var classes = {
    accordionOpen: 'job-listings-greenhouse-api__filter-accordion--open'
  };
  var openAccordion = function openAccordion(accordion, accordionContent) {
    accordion.classList.add(classes.accordionOpen);
    accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
  };
  var closeAccordion = function closeAccordion(accordion, accordionContent) {
    accordion.classList.remove(classes.accordionOpen);
    accordionContent.style.maxHeight = null;
  };
  useEffect(function () {
    var _filters$current;
    var accordions = (_filters$current = filters.current) === null || _filters$current === void 0 ? void 0 : _filters$current.querySelectorAll('[data-accordion]');
    accordions === null || accordions === void 0 || accordions.forEach(function (accordion) {
      var toggle = accordion.querySelector('[data-accordion-toggle]');
      var content = accordion.querySelector('[data-accordion-content]');
      if (toggle && content) {
        toggle.addEventListener('click', function () {
          if (content.style.maxHeight) {
            closeAccordion(accordion, content);
          } else {
            accordions.forEach(function (otherAccordion) {
              var otherContent = otherAccordion.querySelector('[data-accordion-content]');
              closeAccordion(otherAccordion, otherContent);
            });
            openAccordion(accordion, content);
          }
        });
      }
    });
  }, [filters]);
  useEffect(function () {
    var _filters$current2;
    var accordions = (_filters$current2 = filters.current) === null || _filters$current2 === void 0 ? void 0 : _filters$current2.querySelectorAll('[data-accordion]');
    accordions === null || accordions === void 0 || accordions.forEach(function (accordion) {
      var content = accordion.querySelector('[data-accordion-content]');
      if (content) {
        if (accordion.getAttribute('data-accordion-open-on-load') == 'true') {
          openAccordion(accordion, content);
        }
      }
    });
  }, [filterRegions]);
  if (error) return wp.element.createElement("p", null, "Error: ", error);
  return wp.element.createElement(wp.element.Fragment, null, wp.element.createElement("div", {
    ref: filters,
    className: "job-listings-greenhouse-api__filters"
  }, wp.element.createElement("div", null, wp.element.createElement("h3", null, "Filters"), wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__search ".concat(searchTerm != '' ? "job-listings-greenhouse-api__search--active" : "")
  }, wp.element.createElement("label", {
    htmlFor: "search"
  }, "Search:"), wp.element.createElement("input", {
    type: "text",
    id: "search",
    name: "search",
    placeholder: "Search...",
    value: searchTerm,
    onChange: function onChange(e) {
      return setSearchTerm(e.target.value);
    }
  }), searchTerm && searchTerm != '' ? wp.element.createElement("button", {
    onClick: function onClick() {
      setSearchTerm('');
    }
  }, wp.element.createElement("i", {
    className: "fa-solid fa-circle-xmark"
  })) : wp.element.createElement("span", null, wp.element.createElement("i", {
    className: "far fa-search"
  }))), wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__filter"
  }, wp.element.createElement("label", {
    htmlFor: "region-select"
  }, "Select Region: "), wp.element.createElement("select", {
    id: "region-select",
    value: filterRegion,
    onChange: handleChangeRegion
  }, wp.element.createElement("option", {
    value: ""
  }, "Filter by Region"), regions.map(function (region) {
    return wp.element.createElement("option", {
      key: region.code,
      value: region.code
    }, region.title);
  })), wp.element.createElement("div", null, wp.element.createElement("i", {
    className: "fa-light fa-chevron-down"
  }))), wp.element.createElement("div", {
    "data-accordion": true,
    "data-accordion-open-on-load": filterRegions.length ? true : false,
    className: "job-listings-greenhouse-api__filter-accordion job-listings-greenhouse-api__filter-accordion--regions"
  }, wp.element.createElement("button", {
    "data-accordion-toggle": true,
    className: "accordion__toggle"
  }, wp.element.createElement("span", {
    className: "h5"
  }, "Region")), wp.element.createElement("div", {
    "data-accordion-content": true,
    className: "accordion__content"
  }, regions.map(function (region) {
    return wp.element.createElement("button", {
      key: region.code,
      value: region.code,
      onClick: function onClick() {
        return handleRegionClick(region.code);
      },
      className: filterRegions.includes(region.code) ? 'active' : ''
    }, region.title);
  }))), wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__filter"
  }, wp.element.createElement("label", {
    htmlFor: "role-select"
  }, "Select Role: "), wp.element.createElement("select", {
    id: "role-select",
    value: filterRole,
    onChange: function onChange(e) {
      clearSingleJob();
      setFilterRole(e.target.value);
    }
  }, wp.element.createElement("option", {
    value: ""
  }, "All ", ((_regions$find = regions.find(function (r) {
    return r.code === filterRegion;
  })) === null || _regions$find === void 0 ? void 0 : _regions$find.title) || '', ' ', "roles"), roles.map(function (role) {
    return wp.element.createElement("option", {
      key: role,
      value: role
    }, role);
  })), wp.element.createElement("div", null, wp.element.createElement("i", {
    className: "fa-light fa-chevron-down"
  }))), wp.element.createElement("div", {
    "data-accordion": true,
    className: "job-listings-greenhouse-api__filter-accordion job-listings-greenhouse-api__filter-accordion--roles"
  }, wp.element.createElement("button", {
    "data-accordion-toggle": true,
    className: "accordion__toggle"
  }, wp.element.createElement("span", {
    className: "h5"
  }, "Role")), wp.element.createElement("div", {
    "data-accordion-content": true,
    className: "accordion__content"
  }, roles.map(function (role) {
    return wp.element.createElement("button", {
      key: role,
      value: role,
      onClick: function onClick() {
        return handleRoleClick(role);
      },
      className: filterRoles.includes(role) ? 'active' : ''
    }, role);
  }))), filterRegions.length || filterRoles.length ? wp.element.createElement("button", {
    className: "filters__clear",
    onClick: function onClick() {
      setFilterRegions([]);
      setFilterRoles([]);
      clearSingleJob();
    }
  }, "Clear Filters") : null)), singleJob || loadingSingleJob ? wp.element.createElement(wp.element.Fragment, null, wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__back-button"
  }, wp.element.createElement("button", {
    onClick: function onClick() {
      clearSingleJob();
    }
  }, wp.element.createElement("i", {
    className: "far fa-long-arrow-left"
  }), "Back")), loadingSingleJob ? wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__single-job-loading"
  }, wp.element.createElement("p", null, "Loading...")) : singleJob && wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__single-job"
  }, wp.element.createElement("div", {
    className: "single-job__header"
  }, wp.element.createElement("p", {
    className: "single-job__tags"
  }, wp.element.createElement("span", null, (_regions$find$title = (_regions$find2 = regions.find(function (r) {
    return r.code === singleJobRegion;
  })) === null || _regions$find2 === void 0 ? void 0 : _regions$find2.title) !== null && _regions$find$title !== void 0 ? _regions$find$title : singleJobRegion), wp.element.createElement("span", null, singleJob.location.name)), wp.element.createElement("h3", null, singleJob.title), wp.element.createElement("p", null, wp.element.createElement("span", {
    className: "h5"
  }, "Updated: "), function () {
    var dateObj = new Date(singleJob.updated_at);
    var formattedDate = dateObj.toLocaleDateString('en-GB', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    return wp.element.createElement(wp.element.Fragment, null, formattedDate);
  }())), wp.element.createElement("div", {
    className: "single-job__content"
  }, function () {
    var htmlDecode = function htmlDecode(input) {
      var e = document.createElement('textarea');
      e.innerHTML = input;
      return e.value;
    };
    var decoded = htmlDecode(singleJob.content);

    // Remove empty or whitespace-only paragraphs (e.g. <p>&nbsp;</p>, <p> </p>, <p></p>)
    decoded = decoded.replace(/<p>\s*(?:&nbsp;|\u00A0)?\s*<\/p>/gi, '');
    return wp.element.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: decoded
      }
    });
  }()))) : loadingAllJobs ? wp.element.createElement("div", {
    className: "job-listings-greenhouse-api__all-jobs-loading"
  }, wp.element.createElement("p", null, "Loading...")) : wp.element.createElement(wp.element.Fragment, null, wp.element.createElement("ul", {
    className: "job-listings-greenhouse-api__all-jobs"
  }, jobs
  // Search
  .filter(function (job) {
    var _job$location;
    return !searchTerm || job.title.toLowerCase().includes(searchTerm.toLowerCase()) || ((_job$location = job.location) === null || _job$location === void 0 || (_job$location = _job$location.name) === null || _job$location === void 0 ? void 0 : _job$location.toLowerCase().includes(searchTerm.toLowerCase()));
  })
  // Selects
  .filter(function (job) {
    return (!filterRegion || job.region === filterRegion) && (!filterRole || job.title === filterRole);
  })
  // Buttons
  .filter(function (job) {
    var _job$region, _job$title;
    return (filterRegions.length === 0 || filterRegions.includes((_job$region = job.region) !== null && _job$region !== void 0 ? _job$region : '')) && (filterRoles.length === 0 || filterRoles.includes((_job$title = job.title) !== null && _job$title !== void 0 ? _job$title : ''));
  }).map(function (job) {
    var _regions$find$title2, _regions$find3, _job$location2;
    return wp.element.createElement("li", {
      key: job.id,
      className: "job-listings-greenhouse-api__job"
    }, wp.element.createElement("div", null, job.region && wp.element.createElement("span", null, wp.element.createElement("span", null, (_regions$find$title2 = (_regions$find3 = regions.find(function (r) {
      return r.code === job.region;
    })) === null || _regions$find3 === void 0 ? void 0 : _regions$find3.title) !== null && _regions$find$title2 !== void 0 ? _regions$find$title2 : job.region)), ((_job$location2 = job.location) === null || _job$location2 === void 0 ? void 0 : _job$location2.name) && wp.element.createElement("span", null, wp.element.createElement("span", null, job.location.name))), wp.element.createElement("h4", null, job.title), job.updated_at && wp.element.createElement("p", null, wp.element.createElement("span", {
      className: "h5"
    }, "Updated: "), function () {
      var dateObj = new Date(job.updated_at);
      var formattedDate = dateObj.toLocaleDateString('en-GB', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      return wp.element.createElement(wp.element.Fragment, null, formattedDate);
    }()), wp.element.createElement("button", {
      onClick: function onClick() {
        setSingleJobID(job.id);
        setSingleJobRegion(job.region || '');
        var url = new URL(window.location.href);
        url.searchParams.set('region', String(job.region || ''));
        url.searchParams.set('gh_jid', String(job.id));
        window.history.replaceState({}, '', url.toString());
      }
    }, "Apply Now"));
  }))), wp.element.createElement("div", {
    id: "grnhse_app",
    className: "job-listings-greenhouse-api__single-job-form"
  }));
};
export default GreenhouseAPIComponent;